import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import solution from './solutions/solution'
import news from './news/news'
import user from './user/user'
import demand from './demands/demand'
import need from './need/need'
import personal from './personal/personal'
import designer from './designer/designer'
import userPerson from './userPerson/userPerson'
import notice from './notice/notice'
import brand from './brand/brand'
import offerForm from './offerForm/offerForm'
import collection from './collection/collection'
import selection from './selection/selection'
import activities from './activities/index'
import hadoopList from '@/view/hadoop/list'
import ba from 'vue-ba'
import { isMobile, upUserInfo } from '@/utils/common'
import { setCookie } from '@/utils/cookies'

Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    let toIndex = [
      '/solutionBuy.html'
    ]
    if (toIndex.includes(to.path)) {
      return {}
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    ...solution,
    ...news,
    ...user,
    ...demand,
    ...need,
    ...personal,
    ...designer,
    ...userPerson,
    ...notice,
    ...brand,
    ...selection,
    ...activities,
    ...offerForm,
    ...collection,
    {
      path: '/',
      redirect: '/index.html'
    },
    {
      path: '/index.html',
      name: 'home',
      component: home,
      meta: {
        title: '河姆渡方案馆'
      }
    },
    /* 大数据搜索页 */
    {
      path: '/hadoop/list.html',
      name: 'hadoopList',
      component: hadoopList,
      meta: {
        title: '搜索'
      }
    }
  ]
})

vueRouter.beforeEach((to, from, next) => {
  upUserInfo()
  /* 方案限免分享来源标识 */
  if (to.redirectedFrom && to.redirectedFrom.indexOf('/limitFreeShare/') > -1) {
    setCookie('WY_HOMEDO_SOURCE', 'LIMIT_FREE_SHARE')
  }
  let noJumoIndex = [
    'news-detail',
    'solutionDetail',
    'collection-detail',
    'designerApplication',
    'apply',
    'rAndI',
    'projecrRegin',
    'recommendation'
  ]
  let toIndex = [
    '/solutionBuy.html'
  ]
  console.log(to.name)
  // 非手机端 跳转方案PC首页
  if (!isMobile() && !noJumoIndex.includes(to.name)) {
    window.location.href = process.env.PC_SOLUTION_URL
    next()
  }
  // 修复iOS版微信HTML5 History兼容性问题
  document.title = to.meta.title
  if (to.path !== location.pathname && !toIndex.includes(from.path)) {
    // 此处不可使用location.replace
    window.location.assign(to.fullPath)
  } else {
    ba.trackPageview(to.fullPath)
    next()
  }
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js